export const iconFontAwesomeTimeHourglassHalf = (
	<i className="fa-solid fa-hourglass-half"></i>
);
